import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import SessionModule from './session';
import { Settings } from '~/services/settings';

export interface IEligibilityQuestions {
    surveySessionId: string;
    questionId: number;
    answerId: number;
}
@InjectModule({ stateFactory: true }, module)
export default class PharmacyEligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    @Resolve
    public session!: SessionModule;

    public eligibilityData = [] as SurveySessionValueModel[];
    public patientInformationSurveyData = [] as SurveySessionValueModel[];

    public isEligible = false;

    @Mutation
    public async updateEligibilityData(newEligibilityData: typeof PharmacyEligibilityModule.prototype.eligibilityData) {
        this.eligibilityData = newEligibilityData;
    }

    @Mutation
    public async updatePatientInformationSurveyData(newPatientInformationSurveyData: typeof PharmacyEligibilityModule.prototype.patientInformationSurveyData) {
        this.patientInformationSurveyData = newPatientInformationSurveyData;
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Mutation
    public addOrUpdateEligibilityData(newItem: SurveySessionValueModel) {
        const newEligibilityData = this.eligibilityData.filter(item =>
            item.questionId !== newItem.questionId
        );
        newEligibilityData.push(newItem);
        this.eligibilityData = newEligibilityData;
    }

    @Action({ rawError: true })
    public async clearStore() {
        this.updateEligibilityData([]);
        this.updateIsEligible(false);
        this.updatePatientInformationSurveyData([])
    }


    @Action({ rawError: true })
    public checkEligibility(eligibilityData: SurveySessionValueModel[]): boolean {
        const correctAnswers = [
            +this.settings.PharmacyEligibilityFederalNo,
            +this.settings.PharmacyEligibilityPrescribedYes,
            +this.settings.PharmacyEligibilityCommercialInsuranceYes,
            +this.settings.PharmacyEligibilityTermConditionYes,
        ] as number[];

        const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
        this.updateIsEligible(isEligible);
        return isEligible;
    }
}
